
import { useState, useEffect, useCallback } from 'react';
import { getVaccinations, deleteVaccination } from '../services/medicalService';

export interface Vaccination {
  id: string;
  pet_id: string;
  user_id: string;
  vaccine_name: string;
  date_due: string;
  date_given: string | null;
  vet_name: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

export const useVaccinations = (petId: string | undefined) => {
  const [vaccinations, setVaccinations] = useState<Vaccination[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!petId) {
      setIsLoading(false);
      return;
    }

    const fetchVaccinations = async () => {
      try {
        setIsLoading(true);
        const data = await getVaccinations(petId);
        setVaccinations(data);
      } catch (err: any) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVaccinations();
  }, [petId]);

  const refreshVaccinations = useCallback(async () => {
    if (!petId) return;
    try {
      setIsLoading(true);
      const data = await getVaccinations(petId);
      setVaccinations(data);
    } catch (err: any) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [petId]);

  const deleteVaccinationRecord = useCallback(async (vaccinationId: string) => {
    await deleteVaccination(vaccinationId);
    await refreshVaccinations();
  }, [refreshVaccinations]);

  return { vaccinations, isLoading, error, refreshVaccinations, deleteVaccinationRecord };
};
